import { apiGet } from '@/shared/utils/requestBuilder';
import type { GetGlobalUsersParams, GetGlobalUsersResponse } from '../../types/globalUsers';

export const globalUsersService = {
  list: async (params: GetGlobalUsersParams): Promise<GetGlobalUsersResponse> => {
    const query = new URLSearchParams();

    if (params.page) query.set('page', String(params.page));
    if (params.pageSize) query.set('pageSize', String(params.pageSize));
    if (params.search) query.set('search', params.search);
    if (params.tenantId) query.set('tenantId', params.tenantId);
    if (params.role) query.set('role', params.role);
    if (params.status) query.set('status', params.status);
    if (params.sortBy) query.set('sortBy', params.sortBy);
    if (params.sortDir) query.set('sortDir', params.sortDir);
    query.set('includeSummary', 'true');

    const qs = query.toString();
    const url = `/admin/global-users${qs ? `?${qs}` : ''}`;

    const response = await apiGet(url);
    const json = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(json?.error?.message || 'Failed to fetch global users');
    }

    return json.data as GetGlobalUsersResponse;
  },
};
